"use strict";

window.Components.Application.User.ProfilePreviewAffiliation = createReactClass({
  propTypes() {
    return {
      profile: PropTypes.object.isRequired
    };
  },
  render() {
    const avatar = /* @__PURE__ */React.createElement(Components.Basic.Avatar, {
      profile: this.props.profile,
      className: "u-mr2x"
    });
    const header = this.props.profile.display_name;
    const subtext = /* @__PURE__ */React.createElement("div", null, " ", this.props.profile.university, " ");
    return /* @__PURE__ */React.createElement(Components.Compound.ImageHeaderSubtext, {
      image: avatar,
      header,
      subtext,
      url: this.props.profile.url,
      className: "u-m0x"
    });
  }
});